import script from "./TelegramSubmit.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramSubmit.vue?vue&type=script&setup=true&lang=js"

import "./TelegramSubmit.vue?vue&type=style&index=0&id=b7691a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7691a00"]])

export default __exports__